<template>
	<b-form-input
		:state="state"
		:value="value"
		@input="$emit('input', $event)"
		type="text"
	></b-form-input>
</template>

<script>
export default {
	props: ["value", "state"],
	watch: {
		// This watcher is used for data that is searched from netbox -api
		// Without this vuelidate fails
		value(newValue){
			this.$emit('input', newValue)
		}
	}
};
</script>

<style lang="scss" scoped></style>
